import React from 'react';
import { NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Locale } from "../translations/locale";
import { locales } from "./locales";
import { useReactOidc } from "@axa-fr/react-oidc-context";

export const MenuItemAdmin = () => {
    const { oidcUser } = useReactOidc();

    return !!oidcUser.profile.roles && oidcUser.profile.roles.includes('f2453b53-b4c4-4d64-a2f8-b2e279b061e1') ? (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                <Locale id={"header-admin-title"} locales={locales}>Admin</Locale>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem>
                    <NavItem>
                        <NavLink tag={Link} to="/environments">
                            <Locale id={"header-admin-environments"} locales={locales}>Environments</Locale>
                        </NavLink>
                    </NavItem>
                </DropdownItem>
                <DropdownItem>
                    <NavItem>
                        <NavLink tag={Link} to="/resources">
                            <Locale id={"header-admin-resources"} locales={locales}>Resources</Locale>
                        </NavLink>
                    </NavItem>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem>
                    <NavItem>
                        <NavLink href={"/jobs?token=" + oidcUser.id_token}>
                            <Locale id={"header-admin-jobs"} locales={locales}>Jobs</Locale>
                        </NavLink>
                    </NavItem>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    ) : null;
}
